import { DataTable } from '@scuf/datatable';
import React, { useEffect, useState } from 'react';
import {
  formatData,
  formatDataScope2,
  getColumnDetails,
  getColumnDetailsScopeTwo
} from './Scope1TableUtils';
import './Scope1TableTheme.scss';
import { IAny } from '../../DashboardKPIWidgets/IEnergyManagementProps';
import { useFileUploadContext } from '../../../context/FileUploadContext/FileUploadContext';
import moment from 'moment';
import { parseIntBase } from '../../shared/Utils/Constants';
import { useFilterScope1Context } from '../../../context/FilterScope1Context/FilterScope1Context';
import { useTranslation } from '@scuf/localization';
interface IScopeTwoProps {
  data: ScopeTwoData[];
  scopeDetails?: string;
  SetHideFooter?: IAny;
  selectedYear?: string;
  countryCode?: string;
}
/*
interface IFuelType{
  fuelTypeName:string;
  scopeType:string;
}*/
export interface IEmissionFactor {
  siteId: string;
  emissionFactorValue: number;
  effectiveFrom: string;
  countryCode: string;
}
export interface ScopeTwoData {
  combustionTypeId: string;
  fuelType: any;
  emissionFactor: IEmissionFactor[];
  //scopeType:string,
  //effectiveFrom:string,
  fuleTypeId: string;
  // fuelName: string;
  fuelConsumptionId: string;
  //siteId: string;
  emissionFactorId: string;
  //emissionFactorValue: number;
  unit: string;
  year: string;
}
function Scope2Table(props: IScopeTwoProps) {
  const [state, dispatch] =
    props.scopeDetails === 'ScopeError'
      ? useFilterScope1Context()
      : useFileUploadContext();
  const formattedData = formatDataScope2(props.data);

  const [storeData, setstoreData] = useState(formattedData);
  const [cellVal, setcellData] = useState('');
  const [noFuel, setNoFuel] = useState(false);

  useEffect(() => {
    setstoreData(formattedData);
  }, [props.data]);
  const [t] = useTranslation();
  const fuelTypeTableConfig = getColumnDetailsScopeTwo(props.scopeDetails, t);

  return (
    <>
      <DataTable data={storeData} className="emaas-scope1table">
        {fuelTypeTableConfig.map((column) => {
          return (
            <DataTable.Column
              field={column.field}
              header={column.header}
              initialWidth={column.width}
              align={column.align as IAny}
              renderer={(cellData) => {
                if (column.field === 'fuelName')
                  return column.renderer(cellData);
                else if (props.scopeDetails === 'ScopeError') {
                  const { renderer } = column as any;
                  return renderer(
                    cellData,
                    storeData,
                    setstoreData,
                    cellVal,
                    setcellData,
                    props.SetHideFooter,
                    setNoFuel,
                    noFuel
                  );
                } else {
                  return column.renderer(cellData);
                }
              }}
            />
          );
        })}
      </DataTable>
    </>
  );
}
export default Scope2Table;
